
import { Directive, Input } from '@angular/core';
import { AbstractAdornerDirective } from '@common/directives/abstract-adorner';
import { CriteriaObj } from '@common/data-models/criteria/criteria-obj';
import { Adorner } from '@common/data-models/service/adorner';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';


//TODO: FIX ADORNER DIRECTIVE FOR ASSIGNMENT ICON
@Directive({
    selector: "[assignmentIcon]"
})
export class AssignmentIconDirective extends AbstractAdornerDirective {
    private _hasBorder = false;

    @Input()
    get hasBorder() {
        return this._hasBorder;
    }

    set hasBorder(req: BooleanInput) {
        this._hasBorder = coerceBooleanProperty(req);
        if (this.itemType) {
            this.applyAdorner();
        }
    }

    private _hasValue: boolean;

    public get hasValue(): boolean {
        return this._hasValue;
    }

    @Input() public set hasValue(v: boolean) {
        this._hasValue = v;
        if (this.itemType) {
            this.applyAdorner();
        }
    }

    protected lastClass: string = "";
    protected locationID = this.globalTablesService.adornersIDS.AssignmentIcon;

    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj, adorner: Adorner }) {
        if (vcToApply && vcToApply.adorner) {
            let iconContentElArr = (<HTMLElement>this.el.nativeElement).getElementsByClassName('st-icon-content');
            if (iconContentElArr && iconContentElArr.length > 0) {
                for (let idx = 0; idx < iconContentElArr.length; idx++) {
                    let element = iconContentElArr.item(idx);
                    if (element) {
                        if (this.lastClass) {
                            this.renderer.removeClass(element, this.lastClass);
                        }
                        if (vcToApply.adorner.Icon) {
                            this.renderer.addClass(element, vcToApply.adorner.Icon);
                        }
                        if (this.hasBorder) {
                            if (this.hasValue) {
                                this.renderer.setStyle(element, "color", '#ffffff');
                            } else {
                                this.renderer.setStyle(element, "color", vcToApply.adorner.Color);
                            }
                        } else if (vcToApply.adorner.Color) {
                            this.renderer.setStyle(element, "color", vcToApply.adorner.Color);
                        }
                    }
                }
            }
            this.lastClass = vcToApply.adorner.Icon;
            if (vcToApply.adorner.Color) {
                if (this.hasBorder) {
                    this.renderer.setStyle(this.el.nativeElement, "border", '0.125rem solid');
                    if (this.hasValue) {
                        this.renderer.setStyle(this.el.nativeElement, "background", vcToApply.adorner.Color);
                    } else {
                        this.renderer.removeStyle(this.el.nativeElement, "background");
                    }
                    this.renderer.setStyle(this.el.nativeElement, "border-color", vcToApply.adorner.Color);
                } else {
                    this.renderer.removeStyle(this.el.nativeElement, "border");
                    this.renderer.removeStyle(this.el.nativeElement, "border-color");
                    this.renderer.removeStyle(this.el.nativeElement, "background");
                }
            } else {
                this.renderer.removeStyle(this.el.nativeElement, "border-color");
                this.renderer.removeStyle(this.el.nativeElement, "background");
            }
            if (!vcToApply.adorner.Icon && vcToApply.adorner.IconURL) {
                this.renderer.setStyle(this.el.nativeElement, "background-image", ("url(" + vcToApply.adorner.IconURL + ")"));
                this.renderer.setStyle(this.el.nativeElement, "background-size", "contain");
            }
        } else {
            this.fallbackToDefault(this.itemType);
        }
    }

    private fallbackToDefault(type: string) {
        if (type) {
            let predefined = this.predefinedAssignmentIconsMap[type.toUpperCase()];
            if (predefined) {
                let iconContentElArr = (<HTMLElement>this.el.nativeElement).getElementsByClassName('st-icon-content');
                if (iconContentElArr && iconContentElArr.length > 0) {
                    for (let idx = 0; idx < iconContentElArr.length; idx++) {
                        let element = iconContentElArr.item(idx);
                        if (element) {
                            if (this.lastClass) {
                                this.renderer.removeClass(element, this.lastClass);
                            }
                            this.renderer.addClass(element, predefined.icon);
                            if (this.hasBorder && this.hasValue) {
                                this.renderer.setStyle(element, "color", '#ffffff');
                            } else {
                                this.renderer.setStyle(element, "color", predefined.color);
                                this.renderer.setStyle(element, "-webkit-text-fill-color", predefined.color);
                            }
                        }
                    }
                }
                this.lastClass = predefined.icon;
                if (this.hasBorder) {
                    this.renderer.setStyle(this.el.nativeElement, "border", '0.125rem solid');
                    if (this.hasValue) {
                        this.renderer.setStyle(this.el.nativeElement, "background", predefined.color);
                    }
                    this.renderer.setStyle(this.el.nativeElement, "border-color", predefined.color);
                } else {
                    this.renderer.removeStyle(this.el.nativeElement, "border");
                    this.renderer.removeStyle(this.el.nativeElement, "border-color");
                    this.renderer.removeStyle(this.el.nativeElement, "background");
                }
            }
        }
    }
}


